export const TopNavBarHeight = "50px"
export const MainHeight = "96vh"
export const MainWidth = "calc(100vw - 4vh)"

export const MainHeightMobile = "98vh"
export const MainWidthMobile = "calc(100vw - 2vh)"

/**
 * The height of the app's header row, above its separator line.
 *
 * Shared so the assistant's header lands on exactly the same line as the top
 * bar's. Both draw the separator the same way — a 1px element AFTER a row of
 * this height — rather than one using a border and the other a box, which is
 * a pixel out because a border sits inside the box it belongs to.
 *
 * TopNavBarHeight above is a floor left over from an earlier layout, and is
 * shorter than the bar actually renders; this is the real measure.
 */
export const AppHeaderHeight = "64px"
